import Brewery from 'typescript/models/Brewery';

import TopBrewery from './TopBrewery/TopBrewery';

interface ITopBreweriesProps {
  topBreweries: Brewery[];
}

const TopBreweries = ({topBreweries}: ITopBreweriesProps) => {
  return (
    <div className="top-breweries">
      <div className="manager-page__top-wrapper">
        <div className="manager-page__top-ten">
          {topBreweries.map(({id, attributes: {brewery_logo, name, kind, country}}) => (
            <TopBrewery key={id} breweryLogo={brewery_logo} name={name} kind={kind} country={country} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopBreweries;
